import {ErrorMessage, ErrorPageProps} from '../components/ErrorMessage'

import {LoginLayout} from '../components/LoginLayout'
import {GetStaticProps} from 'next'
import {serverSideTranslations} from 'next-i18next/serverSideTranslations'
import {useGLTranslation} from 'notability-services-common-frontend'
import {useMemo} from 'react'

export default function FourOhFour() {
  const {t} = useGLTranslation()
  const errorProps = useMemo(
    () =>
      ({
        pageTitle: t('pageTitle404'),
        pageHeader: t('mobile404Header'),
        pageText: t('mobile404Text'),
        isNotFoundError: true
      } as ErrorPageProps),
    [t]
  )
  return (
    <LoginLayout>
      <ErrorMessage {...errorProps} />
    </LoginLayout>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? 'en', ['common']))
    }
  }
}
